import { createContext } from "react";

import {
  DocumentSearchQuery,
  RegionSearchDocument,
} from "../types/search-display";

type DocSearchQueryContextType = {
  docSearchQueryState: DocumentSearchQuery;
  setDocSearchQueryState: React.Dispatch<
    React.SetStateAction<DocumentSearchQuery>
  >;
};

type UsDocSearchContextType = {
  usRegionSearchDocument: RegionSearchDocument;
  setUsRegionSearchDocument: React.Dispatch<
    React.SetStateAction<RegionSearchDocument>
  >;
};

type EuDocSearchContextType = {
  euRegionSearchDocument: RegionSearchDocument;
  setEuRegionSearchDocument: React.Dispatch<
    React.SetStateAction<RegionSearchDocument>
  >;
};

type AuDocSearchContextType = {
  auRegionSearchDocument: RegionSearchDocument;
  setAuRegionSearchDocument: React.Dispatch<
    React.SetStateAction<RegionSearchDocument>
  >;
};

export const DocSearchQueryContext = createContext<DocSearchQueryContextType>(
  {} as DocSearchQueryContextType
);

export const UsDocSearchContext = createContext<UsDocSearchContextType>(
  {} as UsDocSearchContextType
);

export const EuDocSearchContext = createContext<EuDocSearchContextType>(
  {} as EuDocSearchContextType
);

export const AuDocSearchContext = createContext<AuDocSearchContextType>(
  {} as AuDocSearchContextType
);
